import _extends from "@babel/runtime/helpers/esm/extends";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { kebabCase } from '../../../utils/helpers';
import { Components as FilterCardWrapperComponents } from './filterCardWrapper.style';
function FilterCardWrapper(_ref) {
  let {
    title,
    hasRadio = false,
    expanded = false,
    header,
    body,
    footer,
    onCardToggle
  } = _ref;
  const testId = kebabCase(title);
  return _jsxs(FilterCardWrapperComponents.FilterCardWrapperContainer, {
    children: [_jsxs(FilterCardWrapperComponents.FilterCardWrapperHeader, _extends({
      onClick: () => !hasRadio && onCardToggle(title),
      "data-testId": "filter-bar-title-".concat(testId)
    }, {
      children: [_jsx(FilterCardWrapperComponents.FilterCardWrapperHeaderTitle, {
        children: _jsx("p", {
          children: _jsx("strong", {
            children: title
          })
        })
      }), !hasRadio && _jsx(FilterCardWrapperComponents.FilterCardWrapperIcon, {
        name: expanded ? 'chevron-up' : 'chevron-down',
        size: "24"
      })]
    })), expanded && _jsxs(FilterCardWrapperComponents.FilterCardWrapperContent, {
      children: [_jsx(FilterCardWrapperComponents.FilterCardWrapperContentHeader, _extends({
        "data-testId": "filter-bar-card-header-".concat(testId)
      }, {
        children: header
      })), _jsx(FilterCardWrapperComponents.FilterCardWrapperContentBody, _extends({
        "data-testId": "filter-bar-card-body-".concat(testId)
      }, {
        children: body
      })), footer && _jsx(FilterCardWrapperComponents.FilterCardWrapperContentFooter, _extends({
        "data-testId": "filter-bar-card-footer-".concat(testId)
      }, {
        children: footer
      }))]
    })]
  });
}
export default FilterCardWrapper;